import { create } from 'zustand';
import { addEdge, applyNodeChanges, applyEdgeChanges } from '@xyflow/react';

import { AppState } from './index';
import { temporal } from 'zundo';
import isDeepEqual from 'fast-deep-equal';
import EventEmitter from 'eventemitter3';

export const makeUpV2EventBus = new EventEmitter();

const useStore = create<AppState>()(
  temporal(
    (set, get) => ({
      nodes: [],
      edges: [],
      onNodesChange: changes => {
        set({
          nodes: applyNodeChanges(changes, get().nodes),
        });
      },
      onEdgesChange: changes => {
        set({
          edges: applyEdgeChanges(changes, get().edges),
        });
      },
      onConnect: connection => {
        set({
          edges: addEdge(connection, get().edges),
        });
      },
      setNodes: nodes => {
        set({ nodes });
      },
      setEdges: edges => {
        set({ edges });
      },
    }),
    {
      equality: isDeepEqual,
      // 偏函数
      partialize(state) {
        const { nodes, edges } = state;
        return {
          edges,
          nodes,
        };
      },
    }
  )
);

export enum MakeUpV2EventType {
  SaveTree = 'SaveTree',
  CopyTreeProcess = 'CopyTreeProcess',
  OpenPropertiesView = 'OpenPropertiesView',
  ClosePropertiesView = 'ClosePropertiesView',
}

export const useTemporalStore = () => {
  return {
    ...useStore.temporal.getState(),
    undo: () => {
      useStore.temporal.getState().undo();
      // 通过 eventBus 通知保存画布
      makeUpV2EventBus.emit(MakeUpV2EventType.SaveTree, {
        nodes: useStore.getState().nodes,
        edges: useStore.getState().edges,
      });
    },
    redo: () => {
      useStore.temporal.getState().redo();
      // 通过 eventBus 通知保存画布
      makeUpV2EventBus.emit(MakeUpV2EventType.SaveTree, {
        nodes: useStore.getState().nodes,
        edges: useStore.getState().edges,
      });
    },
  };
};

export const record = (callback: () => void) => {
  const temporalStore = useStore.temporal.getState();
  temporalStore.resume();
  callback();
  temporalStore.pause();
};

// 默认关闭时间机器
useStore.temporal.getState().pause();

export default useStore;
